<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2" id="calibre_pb_0"></div>
<p class="p_norm-center__and__page_break"><span><img alt="" class="calibre3" src="OPS/image0.jpg"/></span></p>
<p class="p_norm-center__and__page_break" id="auto_bookmark_toc_1"><span>Foto: David Schmidt</span></p>
<p class="p_norm-center__and__page_break"><span> </span></p>
<p class="p_norm-center__and__page_break"><span>Für Dunkyn und Dolan</span></p>
<p class="p_norm-center__and__page_break"><span>Danke, dass ihr euer Leben mit mir geteilt und mir so viel gegeben habt.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?614c6466